
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riviste/[slug]",
      function () {
        return require("private-next-pages/riviste/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riviste/[slug]"])
      });
    }
  